import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/ServiceDetailTemplate.jsx");
